import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthCheck from '../../hooks/useAuthCheck';
import SkeletonBodyLoaderComponent from '../Loader/Skeleton/skeletonBody.component';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * Componente que protege rutas verificando si el usuario viene del sistema padre
 * Si no está autenticado, redirige a la página de no autorizado
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthCheck();

  if (isLoading) {
    return (
      <div className="container-fluid pt-3">
        <SkeletonBodyLoaderComponent />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/no-autorizado" replace />;
  }

  return children;
};

export default ProtectedRoute;


